import { InjectionToken } from '@angular/core';

export const YA_API_KEY_TOKEN = new InjectionToken<string>('Yandex map api key token');
